import { Switch } from "@mui/material";
import { colors } from "../styles";

const CustomSwitch = ({
  checked,
  onClick,
  disabled = false,
}: {
  checked?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}) => {
  return (
    <Switch
      sx={{
        margin: "0",
        "& .MuiSwitch-thumb": {
          color: colors.white,
        },
        "& .MuiSwitch-switchBase": {
          "&.Mui-checked": {
            "& + .MuiSwitch-track": {
              opacity: 1,
              backgroundColor: colors.black,
            },
          },
        },
        "& .MuiSwitch-track": {
          backgroundColor: colors.black,
        },
      }}
      // @ts-ignore
      checked={checked}
      onClick={onClick}
      disabled={disabled}
    />
  );
};

export default CustomSwitch;
